import React from "react";
import { ArrowUpRight } from "@untitledui/icons/ArrowUpRight";

const TopicCard = ({ title, description, questionScreen, id, imageUrl }) => {
  return (
    <li className="topic-card flex flex-direction-col flex-between" onClick={() => questionScreen(id)}>
      <div className="flex flex-direction-col flex-align-center flex-justify-center">
        {imageUrl && <img className="topic-card__icon" src={imageUrl} alt={title} />}
        <p className="mb-8 text-color-grey">
          <strong className="text-color-grey-900">{title}</strong>
        </p>
        <p className="medium-text">{description}</p>
      </div>
      {/* <button>
        <ArrowUpRight color={"#fff"} size={24} />
      </button> */}
    </li>
  );
};

export default TopicCard;
